/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ChecklistChecklistidItemsId200,
  GetApiV1ChecklistChecklistidItemsId401,
  GetApiV1ChecklistChecklistidItemsId404,
  GetApiV1ChecklistChecklistidItemsId500,
  GetApiV1ChecklistChecklistidItemsIdPathParams,
  GetApiV1ChecklistChecklistidItemsIdQueryResponse,
} from "../../types/checkListItensController/GetApiV1ChecklistChecklistidItemsId.ts";
import { checkListItemViewModelSchema } from "../checkListItemViewModelSchema.ts";

export const getApiV1ChecklistChecklistidItemsIdPathParamsSchema = z.object({
  checkListId: z.coerce.number().int(),
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ChecklistChecklistidItemsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ChecklistChecklistidItemsId200Schema = z.lazy(
  () => checkListItemViewModelSchema,
) as unknown as ToZod<GetApiV1ChecklistChecklistidItemsId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ChecklistChecklistidItemsId401Schema =
  z.any() as unknown as ToZod<GetApiV1ChecklistChecklistidItemsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ChecklistChecklistidItemsId404Schema =
  z.any() as unknown as ToZod<GetApiV1ChecklistChecklistidItemsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ChecklistChecklistidItemsId500Schema =
  z.any() as unknown as ToZod<GetApiV1ChecklistChecklistidItemsId500>;

export const getApiV1ChecklistChecklistidItemsIdQueryResponseSchema = z.lazy(
  () => getApiV1ChecklistChecklistidItemsId200Schema,
) as unknown as ToZod<GetApiV1ChecklistChecklistidItemsIdQueryResponse>;
